export const subscriptionLevels = {
  FREE: 1,
  MINI: 2,
  STANDARD: 3,
  BUSINESS: 4,
  PRO: 5,
  PREMIUM: 6,
};
